import {API, Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {selectorOrder} from "../../../features/QueuePaymenrt/slices/OrderSlice";
import {useTranslation} from "react-i18next";

const chunkArray = (array: any, size: number) => {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
        chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
}

const getCards = async (entityId: string, isBook?: boolean, notIncludeProducts?: boolean) => {

    const cards = await API.request()
        .endpoint(Endpoints.geoGateway)
        .url('/api/AdditionalCards/GetList')
        .get()
        .addQuery('bookIds', isBook ? [entityId] : [])
        .addQuery('projectIds', isBook ? [] : [entityId])
        .send()
        .then((r) => r.json())

    const cardList = cards?.map((i: any) => ({itemId: i?.id, cardId: i?.cardId, isForPay: i?.isForPay})) || []
    if (cardList?.length === 0) {
        return [];
    }

    let promises

    if (notIncludeProducts) {
        promises = chunkArray(cardList, 50).map(chunk =>
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetList')
                .addQuery('cardIds', chunk.map((i: any) => i.cardId))
                .addQuery('status', 2)
                // не выводить товары для блока коллекционных репродукций
                .addQuery('isProduct', 'false')
                .addQuery('orderByCardIds', 'true')
                .addQuery('isHeaderIgnored', 'true')
                .get()
                .send()
                .then(r => r.json())
                .then(r => { 
                    return r.data?.map((i: any, index: number) => ({
                    ...i,
                    isForPay: chunk[index].isForPay,
                    itemId: chunk[index].itemId
                }))})
        );
    } else {
        promises = chunkArray(cardList, 50).map(chunk =>
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCardsByIds')
                .addQuery('cardIds', chunk.map((i: any) => i.cardId))
                .addQuery('isInit', 'true')
                .get()
                .send()
                .then(r => r.json())
                .then(r => r.map((i: any, index: number) => ({
                    ...i,
                    isForPay: chunk[index].isForPay,
                    itemId: chunk[index].itemId
                })))
        );
    }

    return Promise.all(promises).then(results => {
        return results.flat();
    });
}

export const useGetAdditionalItems = (projectId?: string, isPaidBook?: boolean, isBook?: boolean, notIncludeProducts?: boolean) =>  {
    const [resp, setResp] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { bookCard } = useSelector(selectorOrder)
    const { i18n: {language} } = useTranslation();

    useEffect(() => {

        setIsLoading(true)

        if (isPaidBook && bookCard?.bookData?.cardIds.length) {
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCardsByIds')
                .addQuery('cardIds', bookCard?.bookData?.cardIds || [])
                .addQuery('isInit', 'true')
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    setResp(API.toLang(r?.map((i: any, index: any) => ({...i, isForPay: true})), language))
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
            return;
        }

        if (projectId) {
            getCards(projectId, isBook, notIncludeProducts).then((r) => {
                setIsLoading(false);
                setResp(API.toLang(r, language))
            }).catch((err) => {
                setError(err)
                setIsLoading(false)
            });
        }
    }, [bookCard, language, projectId])

    return [resp, isLoading, error, isBook];
}

export const useGetAdditionalBookItems = (bookId?: string, isPaidBook?: boolean, t?: number) =>  {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const { bookCard } = useSelector(selectorOrder)
        const { i18n: {language} } = useTranslation();

        useEffect(() => {

                setIsLoading(true)

                if (isPaidBook) {

                    if ((bookCard?.bookData?.cardIds || [])?.length === 0) {
                        setIsLoading(false);
                        setResp([])
                        return;
                    }

                    API.request()
                        .endpoint(Endpoints.cardsMnePw)
                        .url('/api/Card/GetCardsByIds')
                        .addQuery('cardIds', bookCard?.bookData?.cardIds || [])
                        .addQuery('exceptPrintSizes', ['A5'])
                        .addQuery('isInit', 'true')
                        .get()
                        .send()
                        .then((r) => r.json())
                        .then((r) => {
                            setIsLoading(false);
                            setResp(API.toLang(r?.filter((i: any) => i?.printQuality !== "A5")?.map((i: any, index: any) => ({...i, isForPay: true})), language))
                        })
                        .catch((e) => {
                            setIsLoading(false);
                            setError(true);
                        })
                    return;
                }

                if (bookId) {
                    getCards(bookId, true).then((r) => {
                        setIsLoading(false);
                        setResp(API.toLang(r, language))
                    }).catch((err) => {
                        setError(err)
                        setIsLoading(false)
                    });
                }
        }, [bookId, isPaidBook, bookCard?.bookData?.cardIds, language, t])

        return [resp, isLoading, error];
    }import {API, Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {selectorOrder} from "../../../features/QueuePaymenrt/slices/OrderSlice";
import {useTranslation} from "react-i18next";

const chunkArray = (array: any, size: number) => {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
        chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
}

const getCards = async (entityId: string, isBook?: boolean, notIncludeProducts?: boolean) => {

    const cards = await API.request()
        .endpoint(Endpoints.geoGateway)
        .url('/api/AdditionalCards/GetList')
        .get()
        .addQuery('bookIds', isBook ? [entityId] : [])
        .addQuery('projectIds', isBook ? [] : [entityId])
        .send()
        .then((r) => r.json())

    const cardList = cards?.map((i: any) => ({itemId: i?.id, cardId: i?.cardId, isForPay: i?.isForPay})) || []
    if (cardList?.length === 0) {
        return [];
    }

    let promises

    if (notIncludeProducts) {
        promises = chunkArray(cardList, 50).map(chunk =>
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetList')
                .addQuery('cardIds', chunk.map((i: any) => i.cardId))
                .addQuery('status', 2)
                // не выводить товары для блока коллекционных репродукций
                .addQuery('isProduct', 'false')
                .addQuery('orderByCardIds', 'true')
                .addQuery('isHeaderIgnored', 'true')
                .get()
                .send()
                .then(r => r.json())
                .then(r => { 
                    return r.data?.map((i: any, index: number) => ({
                    ...i,
                    isForPay: chunk[index].isForPay,
                    itemId: chunk[index].itemId
                }))})
        );
    } else {
        promises = chunkArray(cardList, 50).map(chunk =>
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCardsByIds')
                .addQuery('cardIds', chunk.map((i: any) => i.cardId))
                .addQuery('isInit', 'true')
                .get()
                .send()
                .then(r => r.json())
                .then(r => r.map((i: any, index: number) => ({
                    ...i,
                    isForPay: chunk[index].isForPay,
                    itemId: chunk[index].itemId
                })))
        );
    }

    return Promise.all(promises).then(results => {
        return results.flat();
    });
}

export const useGetAdditionalItems = (projectId?: string, isPaidBook?: boolean, isBook?: boolean, notIncludeProducts?: boolean) =>  {
    const [resp, setResp] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { bookCard } = useSelector(selectorOrder)
    const { i18n: {language} } = useTranslation();

    useEffect(() => {

        setIsLoading(true)

        if (isPaidBook && bookCard?.bookData?.cardIds.length) {
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCardsByIds')
                .addQuery('cardIds', bookCard?.bookData?.cardIds || [])
                .addQuery('isInit', 'true')
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    setResp(API.toLang(r?.map((i: any, index: any) => ({...i, isForPay: true})), language))
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
            return;
        }

        if (projectId) {
            getCards(projectId, isBook, notIncludeProducts).then((r) => {
                setIsLoading(false);
                setResp(API.toLang(r, language))
            }).catch((err) => {
                setError(err)
                setIsLoading(false)
            });
        }
    }, [bookCard, language, projectId])

    return [resp, isLoading, error, isBook];
}

export const useGetAdditionalBookItems = (bookId?: string, isPaidBook?: boolean, t?: number) =>  {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const { bookCard } = useSelector(selectorOrder)
        const { i18n: {language} } = useTranslation();

        useEffect(() => {

                setIsLoading(true)

                if (isPaidBook) {

                    if ((bookCard?.bookData?.cardIds || [])?.length === 0) {
                        setIsLoading(false);
                        setResp([])
                        return;
                    }

                    API.request()
                        .endpoint(Endpoints.cardsMnePw)
                        .url('/api/Card/GetCardsByIds')
                        .addQuery('cardIds', bookCard?.bookData?.cardIds || [])
                        .addQuery('exceptPrintSizes', ['A5'])
                        .addQuery('isInit', 'true')
                        .get()
                        .send()
                        .then((r) => r.json())
                        .then((r) => {
                            setIsLoading(false);
                            setResp(API.toLang(r?.filter((i: any) => i?.printQuality !== "A5")?.map((i: any, index: any) => ({...i, isForPay: true})), language))
                        })
                        .catch((e) => {
                            setIsLoading(false);
                            setError(true);
                        })
                    return;
                }

                if (bookId) {
                    getCards(bookId, true).then((r) => {
                        setIsLoading(false);
                        setResp(API.toLang(r, language))
                    }).catch((err) => {
                        setError(err)
                        setIsLoading(false)
                    });
                }
        }, [bookId, isPaidBook, bookCard?.bookData?.cardIds, language, t])

        return [resp, isLoading, error];
    }